import {Stack, Tab, Tabs} from "@mui/material";
import {Survey, SurveyFormat, SurveyTheme} from "crqlar-react-common/dist/models/survey/survey.model";
import {SurveyQuestion} from "crqlar-react-common/dist/models/survey/surveyQuestion.model";
import React from "react";
import {useTranslation} from "react-i18next";
import SurveyDesignPanel from "./SurveyDesignPanel";
import SurveyQuestionsPanel from "./SurveyQuestionsPanel";

export type LeftPanelTab = 'questions' | 'design';

interface Props {
    survey: Survey
    questions: SurveyQuestion[]
    language: string
    selectedQuestionId?: string
    tab: LeftPanelTab
    onTabChange: (tab: LeftPanelTab) => void
    onSelectQuestion: (questionId: string) => void
    /** A divider click: select the section's first question and focus the section heading in the canvas. */
    onSelectSection: (questionId: string) => void
    onQuestionsChange: (questions: SurveyQuestion[]) => void
    onFormatChange: (format: SurveyFormat) => void
    onThemeChange: (theme: SurveyTheme) => void
    disabled?: boolean
}

function SurveyEditorLeftPanel({
    survey,
    questions,
    language,
    selectedQuestionId,
    tab,
    onTabChange,
    onSelectQuestion,
    onSelectSection,
    onQuestionsChange,
    onFormatChange,
    onThemeChange,
    disabled
}: Props) {
    const {t} = useTranslation();

    return (
        <Stack sx={{height: '100%', minHeight: 0}}>
            <Tabs
                value={tab}
                onChange={(_event, next) => onTabChange(next as LeftPanelTab)}
                variant={'fullWidth'}
                sx={{
                    minHeight: 44,
                    flexShrink: 0,
                    borderBottom: theme => `1px solid ${theme.palette.divider}`,
                    '& .MuiTab-root': {minHeight: 44, textTransform: 'none'},
                }}
            >
                <Tab label={t('Questions')} value={'questions'}/>
                <Tab label={t('Design')} value={'design'}/>
            </Tabs>

            {tab === 'questions' ? (
                <SurveyQuestionsPanel
                    survey={survey}
                    questions={questions}
                    language={language}
                    selectedQuestionId={selectedQuestionId}
                    onSelectQuestion={onSelectQuestion}
                    onSelectSection={onSelectSection}
                    onQuestionsChange={onQuestionsChange}
                    onFormatChange={onFormatChange}
                    disabled={disabled}
                />
            ) : (
                <SurveyDesignPanel
                    theme={survey.theme}
                    onThemeChange={onThemeChange}
                    disabled={disabled}
                />
            )}
        </Stack>
    );
}

export default SurveyEditorLeftPanel;
